import { request } from './client';
import type { LoginResponse, User } from '../types';

/** The session calls: sign in, restore, sign out. Contract: docs/api/LOGIN.md. */
export const authApi = {
  login: (email: string, password: string) =>
    request<LoginResponse>('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    }),

  me: () => request<User>('/auth/me'),

  /** Best-effort: the server forgets the session, the client forgets it either way. */
  logout: () => request<void>('/auth/logout', { method: 'POST' }),
};
